"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function FeaturedArticleHero() {
  const line1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const line2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const line3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const body = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const sideLabel = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const scrollInd = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}